/* tpl-pincode-date.js (2026-10-29): pincode -> delivery range. India only.
   Same date maths as tpl-mat-buybox-extras.js: make time (from the promise
   line's data attributes) + transit by zone, from noon today, "8 to 15 Nov".
   Round 4 (2026-10-30): the trigger is the small "Check pincode" link inside
   the promise line ([data-tpl-pc-link] in a [data-tpl-pc-slot]); this module
   hides that slot for international shoppers, sold-out variants, and while
   the form or a result is showing. */
(function () {
  'use strict';
  if (window.__tplPcInit) return;
  window.__tplPcInit = true;

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAY_MS = 86400000;
  var KEY = 'tpl_pincode';
  var METROS = ['110', '400', '560', '600', '700', '500', '411', '380', '122', '201'];
  var root, link, slot, form, input, msg, avail = {}, queued = false, current = '';
  var linkUsed = false, marketOff = false;

  /* The slot (separator + link) shows only when the market allows it and the
     form/result is not already open. */
  function setLinkUsed(used) {
    linkUsed = !!used;
    if (slot) slot.hidden = linkUsed || marketOff;
  }

  function intlNow() {
    if (document.querySelector('[data-intl-server="1"]')) return true;
    try {
      var keys = ['buckscc_currency', 'buckscc_selected_currency', 'buckscc_auto_currency'];
      for (var i = 0; i < keys.length; i++) {
        var raw = window.localStorage && localStorage.getItem(keys[i]);
        if (!raw) continue;
        var cur = null;
        try { var v = JSON.parse(raw); cur = (v && typeof v === 'object' && (v.currency || v.code)) || (typeof v === 'string' ? v : null); } catch (_) { cur = raw; }
        if (cur && String(cur).toUpperCase().indexOf('INR') === -1) return true;
      }
    } catch (_) {}
    try { var c = (window.Shopify && window.Shopify.country) || ''; if (c && String(c).toUpperCase() !== 'IN') return true; } catch (_) {}
    try {
      var m = document.querySelector('.price .money, .money');
      if (m && m.textContent && /[$€£¥₩]/.test(m.textContent) && !/₹/.test(m.textContent)) return true;
    } catch (_) {}
    return false;
  }

  function transit(pin) {
    var p3 = pin.slice(0, 3), p2 = pin.slice(0, 2);
    if (METROS.indexOf(p3) > -1) return [2, 4];
    if (p2 === '78' || p2 === '79' || p2 === '18' || p2 === '19' || p3 === '744') return [6, 9];
    return [3, 7];
  }

  function num(el, name, fallback) {
    var n = el ? parseInt(el.getAttribute(name), 10) : NaN;
    return isFinite(n) && n >= 0 ? n : fallback;
  }

  function addDays(base, days) { return new Date(base.getTime() + days * DAY_MS); }

  function formatRange(a, b) {
    if (a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()) return a.getDate() + ' to ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
    return a.getDate() + ' ' + MONTHS[a.getMonth()] + ' to ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
  }

  function estimate(pin) {
    var promise = document.querySelector('[data-tpl-mbx-promise]');
    var t = transit(pin), now = new Date();
    var start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12);
    var lo = num(promise, 'data-make-min', 7) + t[0], hi = num(promise, 'data-make-max', 10) + t[1];
    return formatRange(addDays(start, lo), addDays(start, hi));
  }

  function valid(pin) { return /^[1-8]\d{5}$/.test(pin); }

  function showMsg(text, isError) {
    msg.textContent = text;
    msg.classList.toggle('is-error', !!isError);
    msg.hidden = !text;
  }

  function showResult(pin) {
    current = pin;
    msg.textContent = 'To ' + pin + ': arrives ' + estimate(pin);
    msg.classList.remove('is-error');
    var change = document.createElement('button');
    change.type = 'button'; change.className = 'tpl-pc__change'; change.textContent = 'Change';
    change.addEventListener('click', function () { reopen(); });
    msg.appendChild(change);
    msg.hidden = false;
    form.hidden = true; setLinkUsed(true);
    link.setAttribute('aria-expanded', 'false');
  }

  function reopen() {
    form.hidden = false; setLinkUsed(true); link.setAttribute('aria-expanded', 'true');
    showMsg('', false);
    input.value = current; input.focus(); input.select();
  }

  function onSubmit(e) {
    e.preventDefault();
    var pin = (input.value || '').replace(/\s+/g, '');
    if (!valid(pin)) {
      input.setAttribute('aria-invalid', 'true');
      showMsg('Enter a 6-digit pincode', true);
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');
    try { localStorage.setItem(KEY, pin); } catch (_) {}
    showResult(pin);
    window.tplTrack && window.tplTrack('tpl_pincode_check', { pin_prefix: pin.slice(0, 3) });
  }

  function update() {
    var inputEl = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var ok = inputEl && inputEl.value && avail.hasOwnProperty(String(inputEl.value)) ? avail[String(inputEl.value)] : true;
    marketOff = intlNow() || !ok;
    root.hidden = marketOff;
    setLinkUsed(linkUsed);
    if (current && form.hidden && !msg.hidden) showResult(current); /* refresh date text */
  }

  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; update(); }, 0);
  }

  function init() {
    root = document.querySelector('[data-tpl-pc]');
    if (!root) return;
    link = document.querySelector('[data-tpl-pc-link]');
    if (!link) return;
    slot = link.closest('[data-tpl-pc-slot]') || link;
    form = root.querySelector('[data-tpl-pc-form]');
    input = root.querySelector('[data-tpl-pc-input]');
    msg = root.querySelector('[data-tpl-pc-msg]');
    var el = document.querySelector('script[data-tpl-pc-avail]');
    try { avail = el ? JSON.parse(el.textContent) || {} : {}; } catch (_) { avail = {}; }

    link.addEventListener('click', function () {
      form.hidden = false; setLinkUsed(true); link.setAttribute('aria-expanded', 'true'); input.focus();
      window.tplTrack && window.tplTrack('tpl_pincode_open', {});
    });
    form.addEventListener('submit', onSubmit);
    input.addEventListener('input', function () {
      var d = input.value.replace(/\D/g, '').slice(0, 6);
      if (d !== input.value) input.value = d;
      if (input.getAttribute('aria-invalid')) { input.removeAttribute('aria-invalid'); showMsg('', false); }
    });

    var saved = '';
    try { saved = localStorage.getItem(KEY) || ''; } catch (_) {}
    if (valid(saved)) showResult(saved);

    update();
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && (t.closest('variant-selects') || (t.name === 'id' && t.closest('form[action*="/cart/add"]')))) schedule();
    });
    try { if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) window.subscribe(PUB_SUB_EVENTS.variantChange, schedule); } catch (_) {}
    setTimeout(update, 600);
    setTimeout(update, 1600);
    window.addEventListener('storage', update);
  }

  window.tplPincode = { estimate: estimate, transit: transit, valid: valid };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
